import React from 'react';
import {useSelector} from 'react-redux';
import {useState} from 'react';
import {
  Button,
  Modal,
  Form,
  Col,
} from 'react-bootstrap';
import DNS from 'components/DNS/dns.js';
import NotificationAlert from 'react-notification-alert';
import Moment from 'react-moment';
import CircularProgress from '@mui/material/CircularProgress';
import {useTranslation} from 'react-i18next';
import {translations} from '../../../i18n/translations';


const ModalVIEWDELETEReservation = ({showModal, setShowModal,
  setShowModal3, getReservations, getUserReservations, showResPk, showEventTitle,
  showEventName, showDebutDate, showDebutTime, showEndTime,
  showCreatedBy, showSelectedDisposition, showSelectedRoomService,
  showDescription, start, end, getSalle, showReservedIds}) => {
  const user = useSelector((state) => state.user);
  const token = useSelector((state) => state.token);
  const currentBuilding = useSelector((state) => state.currentBuilding);
  const [showDeleteModal, setDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const {t} = useTranslation();

  const notificationAlertRef = React.useRef(null);
  const notify = (place) => {
    const type = 'success';
    let options = {};
    options = {
      place: place,
      message: (
        <div>
          <div>
            <p>{t(translations.MEETING_MODAL_DELETE_CONFIRM)}</p>
          </div>
        </div>
      ),
      type: type,
      icon: 'nc-icon nc-check-2',
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  const DeleteReservation = (event) => {
    event.preventDefault();
    const requestOptions = {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'token ' + token['tokenRedux'],
      },
      body: JSON.stringify({pk: showResPk}),
    };
    setLoading(true);
    fetch(
        DNS +
      '/salle/deleteGetPatchReservation/' +
      currentBuilding['currentbuildingRedux'].pk +
      '/',
        requestOptions,
    ).then(async (response) => {
      const data = await response.json();
      setLoading(false);
      if (data.status == 'OK') {
        notify('tc');
        setDeleteModal(false);
        getReservations(start, end);
        getUserReservations();
        return;
      } else {
        console.log('FAILED REQUEST');
        return;
      }
    });
  };

  const changeToSpace = (toChange) => {
    let tmp = [];
    toChange.map((elem, key) => {
      elem = {'value': elem.value, 'label': elem.label.replace('_', ' ')};
      tmp = tmp.concat(elem);
    });
    return (tmp);
  };

  return (
    <>
      <NotificationAlert ref={notificationAlertRef}/>
      <Modal
        className="modal modal-primary"
        show={showDeleteModal}
        onHide={() => {
          if (!loading) {
            setDeleteModal(false);
          }
        }}
        onSubmit={DeleteReservation}
        autoFocus={false}
        enforceFocus={false}
      >
        <Modal.Header className="justify-content-center">
          <div className="modal-profile">
            <i className="nc-icon nc-notes"></i>
          </div>
        </Modal.Header>
        {!loading ?
          <div className="modal-body">
            <p className="text-center">
              {t(translations.MEETING_MODAL_DELETE)} '{showEventName}' {t(translations.APPOINTMENT_COMMENT2)} {showDebutDate} {t(translations.APPOINTMENT_COMMENT1)} {showDebutTime} {t(translations.APPOINTMENT_COMMENT3)} {showEndTime}?
            </p>
            <Form>
              <Col style={{flex: 1}}>
                <Button className="btn-fill btn-round col-sm-6" type="submit">{t(translations.DELETE)}</Button>
                <Button className="btn-fill btn-round col-sm-6" onClick={() => {
                  setDeleteModal(false), setShowModal(true);
                }}>{t(translations.CANCEL)}</Button>
              </Col>
            </Form>
          </div> :
          <div className="modal-body" style={{alignItems: 'center', justifyContent: 'center', width: '100%', display: 'flex'}}>
            <CircularProgress style={{color: '#F6B540'}}/>
          </div>
        }
      </Modal>
      {/* ##################################### VIEW MODAL BELOW #################################################### */}
      <Modal
        className="modal modal-primary"
        show={showModal}
        onHide={() => setShowModal(false)}
      >
        <Modal.Header className="justify-content-center">
          <div className="modal-profile">
            <i className="nc-icon nc-bulb-63"></i>
          </div>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p>
            <i className="fas fa-id-badge"></i> {t(translations.MEETING_MODAL_INFO)}{' '}
            {showEventTitle}
          </p>
          {showCreatedBy.pk == user['user'].pk ? (
          <p>
            <i className="fas fa-user-tie"></i>{t(translations.MEETING_MODAL_INFO1)}
            {showEventName}
          </p>
        ) : null}
          <p>
            <i className="fas fa-calendar"></i> {t(translations.MEETING_MODAL_INFO2)}{' '}
            <Moment format="DD/MM/YYYY">{showDebutDate}</Moment>
          </p>
          <p>
            <i className="fas fa-clock"></i>{t(translations.MEETING_MODAL_INFO3)} {showDebutTime}
          </p>
          <p>
            <i className="fas fa-clock"></i> {t(translations.MEETING_MODAL_INFO4)} {showEndTime}
          </p>
          <p>
            <i className="fas fa-building"></i>{t(translations.COMPANY) + ' :'}{' '}
            {showCreatedBy.entreprise.nameEntreprise}
          </p>
          {showSelectedDisposition.length != 0 && showCreatedBy.pk == user['user'].pk ? (
          <p>
            <i className="fas fa-eye"></i> {t(translations.MEETING_MODAL_FIELD4)}{' '}
            {showSelectedDisposition.label}
          </p>
        ) : null}
          {showSelectedRoomService.length != 0 && showCreatedBy.pk == user['user'].pk ? (
          <p>
            <i className="fas fa-concierge-bell"></i> {t(translations.MEETING_MODAL_FIELD5)}{' '}
            {changeToSpace(showSelectedRoomService).map(
                (value, key) => value.label + ' ',
            )}
          </p>
        ) : null
          }
          {showCreatedBy.pk == user['user'].pk ? (
          <p>
            <i className="fas fa-comment"></i> {t(translations.COMMENTARY) + ' :'}{' '}
            {showDescription}
          </p>
        ) : null}
        </Modal.Body>
        <div className="modal-body">
          {showCreatedBy.pk == user['user'].pk ? (
          <div>
            <Button
              className="btn-round btn-warning col-md-4"
              onClick={() => {
                setShowModal(false);
                setShowModal3(true);
                getSalle([[showDebutDate, showDebutDate]], showDebutTime, showEndTime, [showResPk]);
              }}
            >
              <i className="fas fa-edit"></i>
            </Button>
            <Button
              className="btn-round btn-danger col-md-4"
              onClick={() => {
                setDeleteModal(true), setShowModal(false);
              }}
            >
              <i className="fas fa-trash"></i>
            </Button>
            <Button
              className="btn-round btn-primary col-md-4"
              onClick={() => setShowModal(false)}
            >
              {t(translations.CLOSE)}
            </Button>
          </div>
        ) :
        <Button
          style={{width: '100%'}}
          onClick={() => setShowModal(false)}
        >
          {t(translations.CLOSE)}
        </Button>}
        </div>
      </Modal>
    </>
  );
};

export default ModalVIEWDELETEReservation;
